<div class="movement-orders no-field-space" *ngIf="serviceTruckOptions.length > 0">
  <sc-flex stretchContent fitHeight>
    <sc-flex-fitting-content>
      <sc-flex stretchContent fitHeight vertical>
        <div>
          <sc-flex>
            <mat-form-field appearance="fill">
              <mat-label>Servicefahrzeug</mat-label>
              <mat-select [formControl]="serviceTruckSelectionControl">
                <mat-option *ngFor="let value of serviceTruckOptions" [value]="value">
                  {{value.identifier}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <ng-container *ngIf="truckGroupsEnabled">
              <ng-container *ngFor="let tg of truckGroupsOfSelectedTruck">
                <sc-content-spacer></sc-content-spacer>
                <sc-bordered [rounded]="true" [highlight]="tg.id === selectedTruckGroup?.id"
                  (click)="selectTruckGroup(tg)">
                  <sc-padding>
                    {{tg.name}}
                  </sc-padding>
                </sc-bordered>
              </ng-container>
            </ng-container>
          </sc-flex>
        </div>
        <sc-content-spacer vertical></sc-content-spacer>
        <sc-flex-fitting-content vertical>


          <sc-scroll-pane>
            <table mat-table [dataSource]="dataSource">
              <ng-container matColumnDef="priority">
                <th mat-header-cell *matHeaderCellDef>
                  <sc-dictionary-label dictionaryKey="tmc-yard.entity.moving-order.priority"></sc-dictionary-label>
                </th>
                <td mat-cell *matCellDef="let row">
                  <sc-icon iconClass="fa-circle-exclamation" *ngIf="row.priority"></sc-icon>
                </td>
              </ng-container>

              <ng-container matColumnDef="referenceDate">
                <th mat-header-cell *matHeaderCellDef>
                  <sc-dictionary-label dictionaryKey="tmc-yard.entity.moving-order.referenceDate"></sc-dictionary-label>
                </th>
                <td mat-cell *matCellDef="let row"> {{row.referenceDate | date:'dd.MM.yy H:mm'}} </td>
              </ng-container>

              <ng-container matColumnDef="scope">
                <th mat-header-cell *matHeaderCellDef>
                  <sc-dictionary-label dictionaryKey="tmc-yard.entity.moving-order.scope"></sc-dictionary-label>
                </th>
                <td mat-cell *matCellDef="let row">
                  <app-transport-scope-icon [scope]="row.scope"></app-transport-scope-icon>
                </td>
              </ng-container>

              <ng-container matColumnDef="identifier">
                <th mat-header-cell *matHeaderCellDef>
                  <sc-dictionary-label dictionaryKey="tmc-yard.entity.moving-order.identifier"></sc-dictionary-label>
                </th>
                <td mat-cell *matCellDef="let row"> {{row.identifier}} </td>
              </ng-container>

              <ng-container matColumnDef="transportReference">
                <th mat-header-cell *matHeaderCellDef>
                  <sc-dictionary-label
                    dictionaryKey="tmc-yard.entity.moving-order.transportReference"></sc-dictionary-label>
                </th>
                <td mat-cell *matCellDef="let row"> {{row.transportReference}} </td>
              </ng-container>

              <ng-container matColumnDef="currentStation">
                <th mat-header-cell *matHeaderCellDef>
                  <sc-dictionary-label
                    dictionaryKey="tmc-yard.entity.moving-order.currentStation"></sc-dictionary-label>
                </th>
                <td mat-cell *matCellDef="let row"> {{row.currentStation}} </td>
              </ng-container>

              <ng-container matColumnDef="targetStation">
                <th mat-header-cell *matHeaderCellDef>
                  <sc-dictionary-label dictionaryKey="tmc-yard.entity.moving-order.targetStation"></sc-dictionary-label>
                </th>
                <td mat-cell *matCellDef="let row"> {{row.targetStation}} </td>
              </ng-container>

              <ng-container matColumnDef="movementStrategy">
                <th mat-header-cell *matHeaderCellDef>
                  <sc-dictionary-label
                    dictionaryKey="tmc-yard.entity.moving-order.movementStrategy.label"></sc-dictionary-label>
                </th>
                <td mat-cell *matCellDef="let row">
                  <ng-container *ngIf="row.movementStrategy">
                    <sc-dictionary-label
                      dictionaryKey="tmc-yard.entity.moving-order.movementStrategy.{{row.movementStrategy}}"></sc-dictionary-label>
                  </ng-container>
                </td>
              </ng-container>

              <ng-container matColumnDef="processingStatus">
                <th mat-header-cell *matHeaderCellDef>
                  <sc-dictionary-label
                    dictionaryKey="tmc-yard.entity.moving-order.processingStatus.label"></sc-dictionary-label>
                </th>
                <td mat-cell *matCellDef="let row">
                  <sc-dictionary-label
                    dictionaryKey="tmc-yard.entity.moving-order.processingStatus.{{row.processingStatus}}"></sc-dictionary-label>
                </td>
              </ng-container>


              <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: false"></tr>
              <tr mat-row *matRowDef="let row; columns: columnsToDisplay" [ngClass]="getRowStyles(row)"
                (click)="toggleSelection(row)"></tr>

            </table>
          </sc-scroll-pane>
        </sc-flex-fitting-content>
      </sc-flex>
    </sc-flex-fitting-content>
    <sc-content-spacer></sc-content-spacer>
    <div class="details-column">
      <sc-sized-container [minWidth]="450" fitHeight>
        <sc-flex vertical fitHeight stretchContent>
          <sc-title>Details</sc-title>
          <sc-content-spacer vertical></sc-content-spacer>
          <sc-flex-fitting-content vertical>
            <app-movement-order-details [movementOrderDetailsId]="movementOrderDetails?.id"
              [serviceTruckId]="selectedServiceTruck?.truckId" (detailsChanged)="onMovementOrderDetailsChanged()">
            </app-movement-order-details>
          </sc-flex-fitting-content>
        </sc-flex>
      </sc-sized-container>
    </div>
  </sc-flex>
</div>
<sc-flex [centered]="true" fitHeight vertical *ngIf="serviceTruckOptions.length === 0">
  <sc-icon iconClass="fa-truck-flatbed fa-6x"></sc-icon>
  <sc-content-spacer vertical></sc-content-spacer>
  <div>no Service Truck available</div>
</sc-flex>
